(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-grid-item"] && !Shopify.designMode) return;
  try {
    /* kone-varinappi 29.10.2026 19.17 (Henry 19.05): kortin värinappi vaihtaa pääkuvan, ei navigoi. Kuvan/nimen linkki -> valitun värin variantti. */
(function () {
  if (window.koneVarinappi) return;
  window.koneVarinappi = 1;
  function vaihda(nappi) {
    var kortti = nappi.closest('.grid-product');
    if (!kortti) return;
    var src = nappi.getAttribute('data-variant-image');
    var srcset = nappi.getAttribute('data-kuva-srcset') || src;
    var img = kortti.querySelector('.grid-product__image-mask .image-wrap img, .grid-product__image-mask .grid__image-ratio img');
    if (img && src) {
      if (img.hasAttribute('data-srcset') || img.classList.contains('lazyload')) img.setAttribute('data-srcset', srcset);
      if (img.hasAttribute('data-src')) img.setAttribute('data-src', src);
      img.setAttribute('srcset', srcset);
      img.setAttribute('src', src);
      var alt = nappi.getAttribute('data-kuva-alt');
      if (alt) img.setAttribute('alt', alt);
    }
    var rivi = nappi.closest('.kone-kortti__varit') || kortti;
    rivi.querySelectorAll('.kone-varinappi').forEach(function (n) {
      var on = n === nappi;
      n.classList.toggle('is-valittu', on);
      n.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    kortti.classList.add('kone-vari-valittu');
    var url = nappi.getAttribute('data-url');
    if (url) kortti.querySelectorAll('a.grid-product__link').forEach(function (a) { a.setAttribute('href', url); });
  }
  document.addEventListener('click', function (e) {
    var nappi = e.target && e.target.closest && e.target.closest('.kone-varinappi');
    if (!nappi) return;
    e.preventDefault();
    vaihda(nappi);
  });
})();
  } catch(e) { console.error(e); }
})();

})();
